import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {getStatscoreConfig} from './factory.js';

import SCHEMA from './statscore.schema.yaml';
import PALETTE_SCHEMA from './statscore.palette-schema.yaml';

class StatscoreFeature extends AbstractVisualFeature {
    get name() {
        return 'Statscore';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {url, livematchProConfigurationId, prematchProConfigurationId, languagesMapping = {}} = this.config;

        return mergeTo(getStatscoreConfig(PALETTE), {
            Statscore: {
                url,
                livematchProConfigurationId,
                prematchProConfigurationId,
                languagesMapping,
            },
        });
    }
}

export const Statscore = new StatscoreFeature(allVisuals);
